
import Mixins from '@/shared'
import firebase from 'firebase/compat/app'
import { Match } from '@/interfaces/match'
import GroupTeamManagement from '@/components/GroupTeamManagement.component.vue'

export interface LocationItem {
  name: string;
  venueId: string;
}
export interface TeamItem {
  name: string;
  orgName: string;
  teamId: string;
  clubId: string;
  shortName: string;
  checked: boolean;
}

export interface Group {
  teams: Array<string>;
  gender: string;
}

export interface Officials {
  name: string;
  role: string;
}
// Component for creating a match in admin interface
export default {
  name: 'CreateMatch',
  components: {
    GroupTeamManagement
  },
  mixins: [Mixins],
  beforeRouteUpdate (to: unknown, from: unknown, next: () => void): void {
    next()
  },
  props: {
    groupId: {
      type: String,
      default: '',
      required: true
    },
    competitionName: {
      type: String,
      default: '',
      required: true
    },
    group: {
      type: Object,
      default: function (): { teams: Array<string>; gender: string } {
        return { teams: [], gender: 'male' }
      },
      required: true
    },
    ageGroup: {
      type: [Object, String],
      default: function (): { name: string } {
        return { name: 'Vaksin' }
      },
      required: true
    }
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data: function () {
    return {
      modal: false,
      display: false,
      dateMenu: false,
      states: ['ANNOUNCED'],
      locations: Array<LocationItem>(),
      inputDate: new Date().toISOString().substr(0, 10),
      createData: {
        groupId: '',
        competitionName: '',
        matchId: '',
        time: '',
        date: {},
        homeTeam: {
          name: '',
          teamId: '',
          clubId: '',
          shortName: '' as string
        },
        awayTeam: {
          name: '',
          teamId: '',
          clubId: '',
          shortName: '' as string
        },
        group: {},
        round: '',
        matchLength: '2x30m|2x5m|p',
        officials: [{
          name: '',
          role: 'referee1'
        }, {
          name: '',
          role: 'referee2'
        }, {
          name: '',
          role: 'secretary'
        }, {
          name: '',
          role: 'timeKeeper'
        }, {
          name: '',
          role: 'delegate'
        }],
        venue: {},
        state: 'ANNOUNCED'
      } as unknown as Match,
      teams: Array<TeamItem>(),
      items: [],
      listener: null,
      model: Array<TeamItem>()
    }
  },
  computed: {
    computedDateFormatted (): string {
      return this.formatDate(this.inputDate)
    }
  },
  methods: {
    // @vuese
    // Saves match to database
    async createMatch (): Promise<void> {
      this.createData.groupId = this.groupId
      this.createData.competitionName = this.competitionName
      this.createData.group = {
        ...this.filterObj(this.group, ['competitionName', 'name', 'gender', 'age', 'cup']),
        competitionName: this.competitionName,
        age: this.ageGroup
      }

      // Resolve club shortName for both teams
      const homeTeam = this.createData.homeTeam || {}
      const awayTeam = this.createData.awayTeam || {}
      const clubTeamsData = (this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data) || {}

      let homeClubId = homeTeam.clubId || (clubTeamsData[homeTeam.teamId] && clubTeamsData[homeTeam.teamId].clubId)
      let awayClubId = awayTeam.clubId || (clubTeamsData[awayTeam.teamId] && clubTeamsData[awayTeam.teamId].clubId)

      // Fetch teams to get clubId if missing
      if (!homeClubId && homeTeam.teamId) {
        await this.$store.dispatch('ClubTeamsModule/fetchById', homeTeam.teamId)
        const teamData = this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data && this.$store.state.ClubTeamsModule.data[homeTeam.teamId]
        homeClubId = teamData && teamData.clubId
        if (homeClubId) this.createData.homeTeam = { ...this.createData.homeTeam, clubId: homeClubId }
      }
      if (!awayClubId && awayTeam.teamId) {
        await this.$store.dispatch('ClubTeamsModule/fetchById', awayTeam.teamId)
        const teamData = this.$store.state.ClubTeamsModule && this.$store.state.ClubTeamsModule.data && this.$store.state.ClubTeamsModule.data[awayTeam.teamId]
        awayClubId = teamData && teamData.clubId
        if (awayClubId) this.createData.awayTeam = { ...this.createData.awayTeam, clubId: awayClubId }
      }

      const clubFetchPromises = []
      if (homeClubId && !(this.$store.state.ClubsModule && this.$store.state.ClubsModule.data && this.$store.state.ClubsModule.data[homeClubId])) {
        clubFetchPromises.push(this.$store.dispatch('ClubsModule/fetchById', homeClubId))
      }
      if (awayClubId && awayClubId !== homeClubId && !(this.$store.state.ClubsModule && this.$store.state.ClubsModule.data && this.$store.state.ClubsModule.data[awayClubId])) {
        clubFetchPromises.push(this.$store.dispatch('ClubsModule/fetchById', awayClubId))
      }
      await Promise.all(clubFetchPromises)

      const clubsDataAfter = (this.$store.state.ClubsModule && this.$store.state.ClubsModule.data) || {}
      if (homeClubId && clubsDataAfter[homeClubId]) {
        this.createData.homeTeam = { ...this.createData.homeTeam, shortName: clubsDataAfter[homeClubId].shortName }
      }
      if (awayClubId && clubsDataAfter[awayClubId]) {
        this.createData.awayTeam = { ...this.createData.awayTeam, shortName: clubsDataAfter[awayClubId].shortName }
      }

      this.createData.homeTeam = this.filterObj(this.createData.homeTeam, ['name', 'shortName', 'teamId', 'clubId'])
      this.createData.awayTeam = this.filterObj(this.createData.awayTeam, ['name', 'shortName', 'teamId', 'clubId'])
      this.createData.date = firebase.firestore.Timestamp.fromDate(new Date(this.inputDate + ' ' + this.createData.time))
      this.createData.spiideoGameIndex = Math.floor(Date.now() / 1000)
      this.$store.dispatch('MatchModule/insert', this.createData).then(() => {
        Object.keys(this.createData).forEach((key) => {
          if (['officials', 'matchId', 'time', 'round'].includes(key)) return
          this.createData[key] = ''
        })
      }).catch((error: unknown) => {
        console.error('Error', error)
      })
    }
  }
}
